// extracted by mini-css-extract-plugin
export default {"content":"q3E4QTRmi4Skp2qCvWMV","subtext":"JSHDfTWpRM49Y2QpuC8c","optionsContainer":"GHKtM0YjOYY3GPSqbVzX","spinnerContainer":"LlgTV_HOwohOyrPkoDY7","hidden":"lkXgn67wbEypSKaqEvsk"};